import React, { Dispatch, FC, ReactNode, SetStateAction, useState } from 'react';

import { styled } from '@mui/material';

export interface ISlidesActions {
  goToSlide: Dispatch<SetStateAction<number>>;
}

interface ISlides {
  selectedSlideIndex?: number;
  setSelectedSlideIndex?: Dispatch<SetStateAction<number>>;
  children: (({ goToSlide }: ISlidesActions) => ReactNode)[];
  className?: string;
}

const Slides: FC<ISlides> = ({
  selectedSlideIndex: controlledSlideIndex,
  setSelectedSlideIndex: setControlledSlideIndex,
  children,
  className,
}) => {
  const [slideIndex, setSlideIndex] = useState(0);
  const selectedIndex = controlledSlideIndex || slideIndex;
  const setSelectedIndex = setControlledSlideIndex || setSlideIndex;
  const slides = children.filter(Boolean);

  return (
    <Wrapper className={className}>
      {new Array(slides.length).fill(null).map((_, index) => {
        const firstSlide = index === 0;
        const slideLeft = firstSlide ? index !== selectedIndex : index === selectedIndex;
        const pos = firstSlide ? 0 : -(index - 1);

        return (
          <Slide
            key={index}
            data-testid={`slide${index}`}
            x={slideLeft ? pos - 1 : pos}
            active={index === selectedIndex}
          >
            {slides[index]({
              goToSlide: setSelectedIndex,
            })}
          </Slide>
        );
      })}
    </Wrapper>
  );
};

export default Slides;

const Slide = styled('div', {
  shouldForwardProp: (prop) => prop !== 'active' && prop !== 'x',
})<{ active: boolean; x: number }>`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 100%;
  left: ${({ x }) => x * 100}%;
  visibility: ${({ active }) => !active && 'hidden'};
  opacity: ${({ active }) => (active ? 1 : 0)};
  transition: 0.3s;
`;
const Wrapper = styled('div')`
  display: flex;
`;
